import { Routes } from '@angular/router';
import { LearnPageComponent } from './learn-page/learn-page.component';

export const LEARN_ROUTES: Routes = [
  {
    path: 'plan/:planId',
    loadComponent: () => import('./learn-plan-page/learn-plan-page.component').then(m => m.LearnPlanPageComponent)
  },
  {
    path: ':plannerLink',
    component: LearnPageComponent
  }
];
